import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FormActions } from '../../../components/form/index.js';
import Table from '../../../components/Table.tsx';
import { useStoresContext } from '../../../contexts/stores/stores.tsx';

const StoresBody = () => {
    const { stores, deleteStore } = useStoresContext();
    const navigate = useNavigate();
    const columns = [
        {
            header: "name",
            name: "name",
            enableSorting: true,
            cell: (props: any) => {
                const { storeID, name } = props.row;
                return (
                    <Link className="nav-link" to={`/admin/stores/${storeID}`}>
                        <span >{name}</span>
                    </Link>
                );
            }
        },
        {
            header: "",
            name: "delete",
            actionHandler: (props: any) => {
                const { storeID } = props.row;
                return deleteStore(storeID);
            },
            enableSorting: false
        }
    ]

    return (
        <>
            <Table columns={columns} rows={stores} />
            <FormActions
                mainAction={() => { navigate("/admin/stores/create"); }}
                mainActionText="Create"
            />
        </>
    );
};

export default StoresBody;